const hackathonsData = [
  {
    title: "AUREX AI 2026",
    place: "3rd Place",
    date: "May 13-14, 2026",
    duration: "6-Hour Hackathon",
    organizer: "Aurex · Bahria University H11, Islamabad",
    description:
      "Built a Smart City Resident Services Portal digitalizing citizen-government interaction with civic request management, permit applications, and real-time analytics.",
    tags: ["Next.js", "TypeScript", "Node.js", "Express", "PostgreSQL", "Prisma", "Zustand", "Tailwind CSS", "JWT"],
    liveLink: "https://aurex-repo-flus.vercel.app/",
    certificateLink: "",
  },
];

export default hackathonsData;
